import type { ReactNode } from "react";
import { useSnapshot } from "valtio";
import { appStore } from "@store/appStore";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { EmptyState } from "@/shared/components/ds";
import styles from "./opLaunchPages.module.css";

/**
 * The chrome every OP page shares (MPN-2229): the document title and the permission gate.
 * The routes exist only while the feature flag is on; this is the second gate, the
 * "Old Platform Reporting" feature (MPN-2365), its own so a role can hold these pages
 * without the Operations Dashboard. The page is a
 * column of cards on the canvas, 12px apart, as the design system lays out every screen.
 */
export function OpLaunchPage({ title, children }: { title: string; children: ReactNode }) {
    useDocumentTitle(title);
    const { loggedInUser } = useSnapshot(appStore);
    const allowed = loggedInUser?.permissions?.hasSomeAccess?.("Old Platform Reporting") ?? false;

    return (
        <div className={styles.page}>
            {allowed ? children : <EmptyState title="You do not have access to this page." body="This page needs the Old Platform Reporting feature." />}
        </div>
    );
}
